import { render, staticRenderFns } from "./SendCustomMixNotificationlPopup.vue?vue&type=template&id=57b6bd6a&scoped=true&"
import script from "./SendCustomMixNotificationlPopup.vue?vue&type=script&lang=js&"
export * from "./SendCustomMixNotificationlPopup.vue?vue&type=script&lang=js&"
import style0 from "./SendCustomMixNotificationlPopup.vue?vue&type=style&index=0&id=57b6bd6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b6bd6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b6bd6a')) {
      api.createRecord('57b6bd6a', component.options)
    } else {
      api.reload('57b6bd6a', component.options)
    }
    module.hot.accept("./SendCustomMixNotificationlPopup.vue?vue&type=template&id=57b6bd6a&scoped=true&", function () {
      api.rerender('57b6bd6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/SendCustomMixNotificationlPopup.vue"
export default component.exports